window.addEventListener('DOMContentLoaded', () => {
	const settingsButton = document.querySelector('button.settings')

	settingsButton.addEventListener('click', e => {
		settingsButton.classList.toggle('settings-open')
	})

	const settingsMenu = document.querySelector('.settings-menu')
	settingsMenu.style.setProperty(
		'--settings-menu-height',
		`${settingsMenu.scrollHeight}px`
	)
	window.addEventListener('resize', () => {
		settingsMenu.style.setProperty('--settings-menu-height', `auto`)
		settingsMenu.style.setProperty(
			'--settings-menu-height',
			`${settingsMenu.scrollHeight}px`
		)
	})
})
